<div class="panel h-100">
  <div *ngIf="showHeader && panelHeaderRef" class="panel-header">
    <ng-content select="[panel-header]"></ng-content>
  </div>
  <div class="panel-content">
    <ng-content select="[panel-content]"></ng-content>
  </div>
</div>
